import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'

import {
  ItinerarioFrotaModel,
  TrechoItinerarioFrota,
} from '../../../core/models/schedule-fleet.model'

@Component({
  selector: 'modal-itinerario-frota',
  standalone: true,
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './modal-itinerario-frota.component.html',
})
export class ModalItinerarioFrotaComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { item: any },
    private dialogRef: MatDialogRef<ModalItinerarioFrotaComponent>,
  ) { }

  get item() {
    return this.data.item
  }

  get itinerario(): ItinerarioFrotaModel[] {
    return this.item?.itinerario ?? []
  }

  trechoLabel(trecho: TrechoItinerarioFrota): string {
    return { O: 'Origem', P: 'Parada', D: 'Destino' }[trecho] ?? trecho
  }

  close(): void {
    this.dialogRef.close()
  }
}
